import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HomeLayout = (props) => {
	return (
		<div id="wrapper">
			<Header template="default" home={true} />
			{props.children}
			<Footer template="home" />
		</div>
	);
};

export default HomeLayout;
